module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"url":"Url","value":"Value","enter_value":"Enter value"},"fr":{"url":"Url","value":"Valeur","enter_value":"Entrez valeur"},"de":{"url":"URL","value":"Wert","enter_value":"Wert eingeben"}}')
  delete Component.options._Ctor
}
